import styled from 'styled-components';

export const FormContainer = styled.form`
  input {
    margin-bottom: 24px;
  }

  button[type="submit"] {
    width: 100%;
  }
`;

export const ForgotPassContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;

  a {
    font-size: 14px;
    color: ${props => props.theme.colors.fontPrimary};
    font-weight: bold;
  }

  .register {
    font-size: 12px;
    font-weight: 400;

    span {
      font-weight: bold;
    }
  }
`
